.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--tap);
  min-height: var(--tap);
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--app-icon);
  transition:
    transform 0.15s var(--ease),
    background-color 0.15s var(--ease),
    opacity 0.15s;
}
.icon-btn:active:not(:disabled) {
  transform: scale(0.92);
}
.icon-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.icon-btn.is-pressed {
  background: color-mix(in srgb, var(--app-icon) 18%, transparent);
}
.icon-btn.v-circle {
  width: var(--tap);
  background: color-mix(in srgb, var(--app-icon) 14%, transparent);
}
.icon-btn.v-filled {
  width: var(--tap);
  background: rgba(0, 0, 0, 0.32);
  color: #fff;
}
.icon-btn.v-white {
  width: var(--tap);
  background: #fff;
  color: #171717;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
}

.btn {
  min-height: var(--tap);
  padding: 0 18px;
  border-radius: 12px;
  border: 0;
  background: rgba(0, 0, 0, 0.06);
  color: #171717;
  font-weight: 600;
}
.btn.is-primary {
  background: #171717;
  color: #fff;
}
.btn.is-danger {
  background: var(--danger);
  color: #fff;
}
.btn.is-small {
  min-height: 36px;
  padding: 0 12px;
  font-size: 15px;
}
.btn:disabled {
  opacity: 0.4;
}

/* ---------------------------------------------------------------- sheet */

.sheet-root {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.sheet-scrim {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  animation: fade-in 0.2s var(--ease);
}
.sheet {
  position: relative;
  width: 100%;
  max-width: 600px;
  max-height: min(78dvh, 720px);
  display: flex;
  flex-direction: column;
  background: var(--sheet-bg);
  color: var(--sheet-fg);
  border-radius: var(--radius-sheet) var(--radius-sheet) 0 0;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.12);
  padding-bottom: var(--safe-bottom);
  animation: sheet-up 0.26s var(--ease);
}
.sheet.is-tall {
  height: min(88dvh, 860px);
  max-height: min(88dvh, 860px);
}
.sheet-grabber {
  width: 36px;
  height: 5px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.15);
  margin: 8px auto 0;
}
.sheet-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px 10px;
  min-height: 60px;
}
.sheet-close {
  flex: none;
}
.sheet-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  flex: 1;
}
.sheet-body {
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  flex: 1;
  min-height: 0;
}

@keyframes sheet-up {
  from {
    transform: translateY(100%);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
}

/* ---------------------------------------------------------------- segmented (reference: Photos | Collections) */

.segmented {
  display: inline-flex;
  padding: 4px;
  gap: 2px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
}
.segmented button {
  min-height: 40px;
  padding: 0 18px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #171717;
  font-size: 16px;
}
.segmented button.is-on {
  background: #e9e9eb;
  font-weight: 500;
}

/* ---------------------------------------------------------------- switch */

.switch {
  position: relative;
  width: 51px;
  height: 31px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(120, 120, 128, 0.32);
  transition: background-color 0.2s var(--ease);
  flex: none;
}
.switch.is-on {
  background: #34c759;
}
.switch-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s var(--ease);
}
.switch.is-on .switch-knob {
  transform: translateX(20px);
}
.switch:disabled {
  opacity: 0.4;
}

/* ---------------------------------------------------------------- grouped lists */

.group {
  margin: 0 0 22px;
}
.group-title {
  margin: 0 0 6px 16px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  opacity: 0.7;
}
.group-body {
  background: var(--group-bg);
  color: #171717;
  border-radius: var(--radius-group);
  overflow: hidden;
}
.group-footer {
  margin: 6px 16px 0;
  font-size: 13px;
  opacity: 0.72;
}
.row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  padding: 8px 16px;
  border: 0;
  background: transparent;
  text-align: left;
  color: inherit;
}
.row + .row {
  box-shadow: inset 0 0.5px 0 var(--hairline);
}
.row.is-button:active {
  background: rgba(0, 0, 0, 0.05);
}
.row.is-danger {
  color: var(--danger);
}
.row-icon {
  flex: none;
  opacity: 0.8;
}
.row-label {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.row-detail {
  font-size: 13px;
  color: var(--muted);
}
.row-control {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
}
.row-chevron {
  opacity: 0.35;
  flex: none;
}
.row select,
.row input[type='time'],
.row input[type='date'],
.row input[type='number'],
.row input[type='text'] {
  min-height: 36px;
  border: 0;
  border-radius: 8px;
  background: rgba(118, 118, 128, 0.12);
  padding: 4px 10px;
  max-width: 52vw;
}

/* ---------------------------------------------------------------- screen chrome */

.screen {
  min-height: 100dvh;
  padding: var(--safe-top) calc(16px + var(--safe-right)) calc(32px + var(--safe-bottom)) calc(16px + var(--safe-left));
  max-width: 680px;
  margin: 0 auto;
}
.screen-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  min-height: 52px;
  margin: 0 -16px 8px;
  padding: calc(var(--safe-top)) 4px 0;
  background: color-mix(in srgb, var(--app-bg) 88%, transparent);
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
}
.screen-header-side {
  display: flex;
  align-items: center;
}
.screen-header-side.is-end {
  justify-content: flex-end;
}
.screen-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------------------------------------------------------------- confirm */

.confirm-root {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.confirm {
  position: relative;
  width: 100%;
  max-width: 340px;
  background: #fff;
  color: #171717;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: fade-in 0.15s var(--ease);
}
.confirm h2 {
  margin: 0 0 8px;
  font-size: 18px;
}
.confirm p {
  margin: 0 0 16px;
  color: var(--muted);
  font-size: 15px;
}
.confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* ---------------------------------------------------------------- toasts & banners */

.toasts {
  position: fixed;
  left: 50%;
  bottom: calc(16px + var(--safe-bottom));
  transform: translateX(-50%);
  z-index: 90;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(92vw, 440px);
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(23, 23, 23, 0.94);
  color: #fff;
  font-size: 15px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  animation: sheet-up 0.25s var(--ease);
}
.toast.is-error {
  background: #b42318;
}
.toast button {
  background: transparent;
  border: 0;
  color: #ffd84d;
  font-weight: 700;
  min-height: 36px;
}
.toast .toast-text {
  flex: 1;
}

.reminder-banner {
  position: fixed;
  top: calc(8px + var(--safe-top));
  left: 50%;
  transform: translateX(-50%);
  z-index: 95;
  width: min(94vw, 460px);
  background: rgba(255, 255, 255, 0.97);
  color: #171717;
  border-radius: 20px;
  padding: 12px 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.22);
  animation: banner-down 0.3s var(--ease);
}
.reminder-banner h2 {
  margin: 0;
  font-size: 15px;
}
.reminder-banner p {
  margin: 2px 0 8px;
  font-size: 14px;
  color: var(--muted);
}
.reminder-banner .reminder-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
@keyframes banner-down {
  from {
    transform: translate(-50%, -120%);
  }
}

.chip-row {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 2px 0 8px;
  scrollbar-width: none;
}
.chip-row::-webkit-scrollbar {
  display: none;
}
.chip {
  flex: none;
  min-height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 0;
  background: rgba(0, 0, 0, 0.07);
  color: inherit;
  font-size: 15px;
  white-space: nowrap;
}
.chip.is-on {
  background: #171717;
  color: #fff;
}

.search-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  background: rgba(118, 118, 128, 0.14);
  margin-bottom: 10px;
}
.search-field input {
  flex: 1;
  border: 0;
  background: transparent;
  min-height: 40px;
  outline: none;
  min-width: 0;
}
.search-field:focus-within {
  outline: 2px solid var(--focus);
}

.empty-state {
  text-align: center;
  padding: 40px 16px;
  opacity: 0.75;
}

.text-input {
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid var(--hairline);
  background: #fff;
}
textarea.text-input {
  min-height: 72px;
  resize: vertical;
}
